import { useQueryFromRemote } from '@flex-packages/remote-hooks';
import '../file/apis/file-download-controller-api.mjs';
import '../file/apis/file-info-controller-api.mjs';
import { getFileSourceTypeRestrictionsRemote } from '../file/apis/file-restriction-controller-api.mjs';
import '../file/apis/image-download-controller-api.mjs';
import '../file/apis/temporary-file-upload-controller-api.mjs';

function useGetFileSourceTypeRestrictionsRemote(options) {
  return useQueryFromRemote({
    remote: getFileSourceTypeRestrictionsRemote,
    options
  });
}

export { useGetFileSourceTypeRestrictionsRemote };
//# sourceMappingURL=useGetFileSourceTypeRestrictionsRemote.mjs.map
